import { Country } from '../../api/countryShortcut';
import { canadaStates } from '../../resources/canadaStates';
import { ContactDetailsValues } from '../../state/types';

export const UNITED_STATES = 'United States';
export const CANADA = 'Canada';
export const COUNTRY_LIST = [UNITED_STATES, CANADA] as const;
export type FieldName = keyof ContactDetailsValues;

export const US_STATES_LIST = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const CA_STATES_LIST = canadaStates.map((option) => option.value);

interface ContactDetailsPlaceholders {
  zipCode: string;
  state: string;
}

const PLACEHOLDERS_BY_COUNTRY: Record<Country, ContactDetailsPlaceholders> = {
  'United States': {
    state: 'State *',
    zipCode: 'Zip code *',
  },
  Canada: {
    state: 'Province *',
    zipCode: 'Postal code *',
  },
};

export const getPlaceholdersByCountry = (country: Country) =>
  PLACEHOLDERS_BY_COUNTRY[country] ?? PLACEHOLDERS_BY_COUNTRY['United States'];
